import api from './api';

const authService = {
  login: async (email, password) => {
    const response = await api.post('/login', { email, password });
    // Devolver solo los datos, no el objeto axios completo
    return response.data;
  },

  logout: async () => {
    localStorage.removeItem('psych_app_token');
    localStorage.removeItem('psych_app_user');
  },

  getCurrentUser: () => {
    return JSON.parse(localStorage.getItem('psych_app_user') || 'null');
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('psych_app_token');
  }
};

export default authService;
